'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUniqueIconNames = getUniqueIconNames;
exports.getIconNamePropType = getIconNamePropType;

var _icons = require('icons/icons');

var _icons2 = _interopRequireDefault(_icons);

var _react = require('react');

var _IconAliases = require('../../icon/IconAliases');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var iconNames = void 0;
var propType = void 0;

function getUniqueIconNames() {
  if (!iconNames) {
    iconNames = [].concat(_toConsumableArray(Object.keys(_IconAliases.ICON_ALIASES)), _toConsumableArray(Object.keys(_icons2.default).map(function (key) {
      return _icons2.default[key];
    }))).filter(function (cur, index, arr) {
      return arr.indexOf(cur) === index;
    });
  }
  return iconNames;
}

function getIconNamePropType() {
  if (!propType) {
    propType = _react.PropTypes.oneOf(getUniqueIconNames());
  }
  return propType;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/utils/propTypes/iconName.js
// module id = 91
// module chunks = 0 1